import { isEmptyArray, isNotEmpty } from '../objects/isEmpty';

export function includesAny<T>(mustBeIncluded: T[] | undefined, values: T[] | undefined): boolean {
	// If the list of what must be included is empty, consider that to be included
	if (isEmptyArray(mustBeIncluded)) {
		return true;
	}
	// If the list of values is empty, nothing can be included
	if (isEmptyArray(values)) {
		return false;
	}
	return Boolean(mustBeIncluded?.some((value) => values?.includes(value)));
}

export function includesOnly<T>(mustBeIncluded: T[] | undefined, values: T[] | undefined): boolean {
	// If the list of what must be included is empty, consider that to be included
	if (isEmptyArray(mustBeIncluded)) {
		return isNotEmpty(values);
	}

	if (isEmptyArray(values)) {
		return false;
	}

	return Boolean(values?.every((value) => mustBeIncluded?.includes(value)));
}
